import colors from "vuetify/es5/util/colors";
import { ThemeOptions } from "vuetify/types/services/theme";

export const budgensTheme: ThemeOptions = {
  themes: {
    light: {
      primary: "#114232",
      secondary: "#88b407",
      accent: "#f97467",
      error: colors.pink.base,
      warning: colors.yellow.base,
      info: colors.blue.base,
      success: colors.lightGreen.base,
    },
  },
};
